import PartnerService from '../../services/Partner.service';
import WidgetService from '../../services/Widget.service';
import PagehitService from '../../services/PageHit.service';

class WidgetControllerService {
	setModel(model) {
		this.model = model;
		this.model.state = {
			lessonTypes: [],
			resorts: [],
			selectedResort: '',
			selectedLessonType: '',
			dateStart: '',
			dateEnd: '',
			isValid: false
		};
	}
	async refresh() {
		this.data = await WidgetService.getWidgetData();
		const { partnerId } = await PartnerService.getPartnerId();
		// const pageHitId = await PagehitService.getPageHitId(partnerId);
		this.refreshPageHitId();

		const resorts = this.data.resorts.map(resort => ({ id: resort._id, name: resort.name }));
		this.model.setState({ resorts, partnerId });
		this.setLessonTypes();
	}
	async refreshPageHitId(){
		const { partnerId } = await PartnerService.getPartnerId();
		const pageHitId = await PagehitService.getPageHitId(partnerId);
		this.model.setState({pageHitId});
	}
	setLessonTypes(resortId) {
		resortId = this.model.state.selectedResort;
		let lessonTypes = []
		if (resortId) {
			// eslint-disable-next-line
			lessonTypes = [].concat(this.data.resorts.filter(resort => resort._id == resortId)[0].categories).map(category => ({ id: category._id, name: category.name }));
		}
		this.model.setState({ lessonTypes: lessonTypes });
	}
	onChange(e) {
		const action = { [e.target.name]: e.target.value };
		this.model.setState(action, () => this.setLessonTypes());
	}
	gotoSkiBro(e) {
		e.preventDefault();
		WidgetService.gotoSkiBro(this.model.state);

		// when the user has gone to skibro website, we must refresh the partnerRequestId.
		setTimeout(()=>{
			this.refreshPageHitId();
		}, 1000);
	}
}

const widgetControllerService = new WidgetControllerService();

export default widgetControllerService;


// WEBPACK FOOTER //
// ./src/components/widget/WidgetControllerService.js